import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import calendar from 'dayjs/plugin/calendar';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(calendar);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(updateLocale);

// Configuration du calendrier français
dayjs.updateLocale('fr', {
    calendar: {
        sameDay: '[aujourd\'hui à] LT',
        nextDay: '[demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L'
    }
});

// Configuration du calendrier allemand
dayjs.updateLocale('de', {
    calendar: {
        sameDay: '[heute um] LT',
        nextDay: '[morgen um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[gestern um] LT',
        lastWeek: '[letzten] dddd [um] LT',
        sameElse: 'L'
    }
});

dayjs.tz.setDefault('Europe/Paris');
dayjs.locale('fr');

export default dayjs;
